import React from "react";
import Img from "../../molecules/Img";
import idsc from "../../../assets/pics/aboutus/idsc.png";
import livedhere from "../../../assets/pics/aboutus/livedhere.png";
import curlturemin from "../../../assets/pics/aboutus/cultureministry.png";
import nationalorg from "../../../assets/pics/aboutus/nationaalorg.png";
import { useTranslation } from "react-i18next";

export default function Aboutus() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-custom-gradient px-[15px] pt-[60px] pb-[20px] md:px-[100px] md:pt-[30px] lg:px-[200px] lg:pt-[60px]">
      <div className="bg-yelow-500 flex flex-col justify-around items-center w-full px-[0px] md:px-[50px]">
        <div className="mt-[20px] mb-[6px] md:mt-[30px] ">
          <div>
            <Img src={livedhere} aboutus_livedhere />
          </div>
        </div>
        <div className="flex justify-around items-center w-full px-[0px] md:px-[50px]">
          <div>
            <Img src={idsc} aboutus_idsc />
          </div>
          <div>
            <Img src={curlturemin} aboutus_idsc />
          </div>
          <div>
            <Img src={nationalorg} aboutus_idsc />
          </div>
        </div>
      </div>
      <div className="mt-[12px] w-full flex-1 rounded-[10px] bg-[#F5F5F54D] p-[4px] text-center md:p-[40px]">
        <div className="font-cairo-bold mb-[10px]">{t("about.title")}</div>
        <div className="font-cairo-regular">{t("about.body")}</div>
      </div>
    </div>
  );
}
